import * as moment from 'moment'
import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { EditEventEmails } from './components/edit.event.emails/edit.event.emails';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { TrainingEvent } from '../../models/domain/training.event';
import { TrainingEventSubscription, AttendanceStatusTypes, SubscriptionMethodTypes } from '../../models/domain/training.event.subscription';
import { UpdateTrainingEventSubscriptionStatusesRequest, UpdateTrainingEventSubscriptionStatusesRequestArray } from '../../models/ss-api/requests/update.training.event.subscription.statuses.request';
import { WindowSettings } from '../../../app/services/window-dialogs/window.settings';
import { WindowService } from '../../../app/services/window-dialogs/window.service';
import { WindowTypes } from '../../../app/services/window-dialogs/window.event';
import { MenuItem } from 'primeng/primeng';
import { AddAttendeeDialog } from '../add.attendee/add.attendee.dialog';
import { UpdateTrainingEventRequest } from '../../models/ss-api/requests/update.training.event.request';
import { AddTrainingEventSubscriptionRequestArray, AddTrainingEventSubscriptionRequest } from '../../models/ss-api/requests/add.training.event.subscription.request';
import { UpdateTrainingEventSubscriptionRequestArray, UpdateTrainingEventSubscriptionRequest } from '../../models/ss-api/requests/update.training.event.subscription.request';
import { AdminItemArray } from '../../models/domain/admin.item';
import { TrainingClassArray } from '../../models/domain/training.class';
import { TemplateTypes } from '../../../app/models/domain/email.template.item';
import { EmailWindowType } from '../../../app/models/domain/email.window.request';
import { AddTrainingEventSubscriptionOnlyRequest } from '../../../app/models/ss-api/requests/add.training.event.subscription.only.request';
import { ProductItemBasicsArray, ProductItemBasics } from '../../../app/models/domain/product.item.basics';
import { TrainingEventSubscriptionCertificateResponse, CertificateTypes, TrainingEventSubscriptionCertificateResponseArray } from '../../../app/models/ss-api/responses/training.event.subscription.certificate.response';
import { NotificationGroupReportTypes } from '../../../app/models/ss-api/requests/training.email.request';
import { RescheduleAttendeeDialog } from '../reschedule.attendee/reschedule.attendee.dialog';
import { TrainingEmailEventTypes } from '../../../app/models/ss-api/requests/training.email.event.types';
import { MemberDashboard } from '../../../app/models/ss-api/responses/member.dashboard.response';
import { EmailDialog } from '../email/email.dialog';
import { UserRolesService } from '@services/user.roles.service';

export interface IEditEventDialogModel {
    title: string;
    event: TrainingEvent;
    currentVersion ?: string;
    minimumVersionv2 ?: string;
    minimumVersionv3 ?: string;
}

class Attendee {
    ID: number;
    Attendee: TrainingEventSubscription;
    Actions: MenuItem[];
    DisplayInfo: Boolean;
}

@Component({
    selector: 'edit-event-dialog',
    styleUrls: ['./edit.event.dialog.css'],
    templateUrl: './edit.event.dialog.html'
})

export class EditEventDialog extends DialogComponent<IEditEventDialogModel, TrainingEvent> implements IEditEventDialogModel, OnInit {
    @ViewChild(EditEventEmails) EventEmails: EditEventEmails;
    IsBusy: Boolean = true;
    title: string;
    event: TrainingEvent = new TrainingEvent();
    currentVersion: string;
    minimumVersionv2: string;
    minimumVersionv3: string;
    eventDate: Date;
    eventTime: Date;
    EventForm: FormGroup;
    productSelection: Array<Object>;
    Products: ProductItemBasicsArray;
    Attendees: Array<Attendee> = new Array<Attendee>();
    SelectedAttendees: Array<TrainingEventSubscription> = new Array<TrainingEventSubscription>();
    AttendeeActions: Array<MenuItem>;
    isToggleAll: Boolean = false;
    Trainers: AdminItemArray = new AdminItemArray();
    TrainingClasses: TrainingClassArray = new TrainingClassArray();
    DisplayAllInfo: Boolean = false;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, public router: Router, private windowService: WindowService, private sweetAlert: SweetAlertService, private roles: UserRolesService) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.gb.GetStructureStudiosProductsBasics().then(response => {
            this.Products = response;
        })
        if (this.event && this.event.ID) {
            this.loadEvent();
        } else {
            this.event = new TrainingEvent();
        }
        this.getClasses();
        this.getTrainers();
        this.EventForm = new FormGroup({
            'date': new FormControl(new Date(this.event.EventDateTime), [Validators.required]),
            'time': new FormControl(new Date(this.event.EventDateTime), [Validators.required]),
            'trainer': new FormControl(this.event.TrainerID, [Validators.required]),
            'class': new FormControl(this.event.TrainingClassID, [Validators.required])
        })
        this.AttendeeActions = [
            {
                title: 'Registered',
                label: 'Set Status to Registered',
                command: (onclick) => {
                    this.updateAttendeeStatuses(1);
                }
            },
            {
                title: 'Attended',
                label: 'Set Status to Attended',
                command: (onclick) => {
                    this.updateAttendeeStatuses(2);
                }
            },
            {
                title: 'Cancelled',
                label: 'Set Status to Cancelled',
                command: (onclick) => {
                    this.updateAttendeeStatuses(3);
                }
            },
            {
                title: 'Rescheduled',
                label: 'Set Status to Rescheduled',
                command: (onclick) => {
                    this.updateAttendeeStatuses(4);
                }
            },
            {
                title: 'No Show',
                label: 'Set Status to No Show',
                command: (onclick) => {
                    this.updateAttendeeStatuses(5);
                }
            }
        ]
    }

    loadEvent() {
        this.IsBusy = true;
        let disposable = this.api.GetTrainingEventByID(this.event.ID).subscribe(response => {
            this.IsBusy = false;
            this.event = response.Data;
            this.Attendees = [];
            this.eventDate = response.Data.EventDateTime;
            this.eventTime = response.Data.EventDateTime;
            this.event.Attendees.forEach(function (attendee) {
                let actions = {
                    ID: attendee.ID,
                    Attendee: attendee,
                    DisplayInfo: false,
                    Actions: this.ActionsForAttendee(attendee)
                }
                this.Attendees.push(actions);
            }, this)

            this.Attendees = this.SortedAttendees(this.Attendees);
            disposable.unsubscribe();
        })
    }

    reloadActions() {
        this.IsBusy = true;
        this.Attendees = [];
        this.event.Attendees.forEach(function (attendee) {
            let actions = {
                ID: attendee.ID,
                Attendee: attendee,
                DisplayInfo: false,
                Actions: this.ActionsForAttendee(attendee)
            }
            this.Attendees.push(actions);
        }, this)
        this.Attendees = this.SortedAttendees(this.Attendees);
        this.IsBusy = false;
    }

    getTrainers() {
        let disposable = this.api.GetTrainers().subscribe(result => {
            this.Trainers = result.Data;
            disposable.unsubscribe();
        })
    }

    getClasses() {
        let disposable = this.api.GetAdminTrainingClasses().subscribe(result => {
            this.TrainingClasses = result.Data;
            disposable.unsubscribe();
        })
    }

    toggleAllAttendees() {
        if (!this.isToggleAll) {
            this.Attendees.forEach(function (attendee) {
                if (!this.isSelected(attendee.Attendee)) {
                    this.toggleAttendee(attendee.Attendee);
                }
            }, this)
        } else {
            this.SelectedAttendees = [];
        }
    }

    toggleAttendee(attendee: TrainingEventSubscription) {
        if (this.SelectedAttendees.indexOf(attendee) < 0) {
            this.SelectedAttendees.push(attendee);
        } else {
            this.SelectedAttendees.splice(this.SelectedAttendees.indexOf(attendee), 1);
        }
    }

    SortedAttendees(attendees: Attendee[]): Attendee[] {
        return attendees.sort((a, b) => {
            const compareStatus = a.Attendee.AttendancestatusType - b.Attendee.AttendancestatusType;
            const compareName = a.Attendee.MemberName.localeCompare(b.Attendee.MemberName);
          
            return compareStatus || compareName;
          })
    }

    isSelected(attendee: TrainingEventSubscription): Boolean {
        if (this.SelectedAttendees.indexOf(attendee) < 0) {
            return false;
        } else {
            return true;
        }
    }

    determineDisplayIcon(Product: string){
        if (Product == "Pool Studio"){
            return "../../assets/images/icons/logo-icons-pool-studio-xs.png";
        }
        else{
            if (Product == "VizTerra"){
                return "../../assets/images/icons/logo-icons-vizterra-xs.png";
            }
            else{
                return "../../assets/images/icons/logo-icons-vip3d-xs.png";
            }
        }
    }

    isValidSoftwareVersion(attendee: TrainingEventSubscription): Boolean {
        if (attendee.SoftwareVersion.slice(0,2) == "2."){
            //v2 check
            if (this.minimumVersionv2.slice(0, this.minimumVersionv2.length - 1) <= attendee.SoftwareVersion && attendee.LicenseStatus != 'Cancelled') {
                return true;
            } else {
                return false;
            }    
        }
        else{
            //v3 check
            var installedMajor = 0;
            var installedMinor = 0;
            var installedPatch = 0;
            var minimumMajor = 0;
            var minimumMinor = 0;
            var minimumPatch = 0;

            var aryInstalled = attendee.SoftwareVersion.split(".");
            installedMajor = parseInt(aryInstalled[0]);
            if (aryInstalled.length > 1)
                installedMinor = parseInt(aryInstalled[1]);
            if (aryInstalled.length > 2)
                installedPatch = parseInt(aryInstalled[2]);

            var aryMinimum = this.minimumVersionv3.split(".");
            minimumMajor = parseInt(aryMinimum[0]);
            if (aryMinimum.length > 1)
                minimumMinor = parseInt(aryMinimum[1]);
            if (aryMinimum.length > 2)
                minimumPatch = parseInt(aryMinimum[2]); 

            var OldVersion = (installedMajor < minimumMajor)
                || (installedMajor == minimumMajor && installedMinor < minimumMinor)
                || (installedMajor == minimumMajor && installedMinor == minimumMinor && installedPatch < minimumPatch);            

            return !OldVersion;
        }
    }

    VersionForProduct(id: number): String {
        return this.currentVersion;
    }

    ActionsForAttendee(attendee: TrainingEventSubscription): Array<Object> {
        let noteLabel = 'Add Note';
        if (attendee.SubscriptionNotes.length > 0) {
            noteLabel = 'Edit Note';
        }
        let actions = [
            {
                title: String(attendee.ID),
                label: noteLabel,
                command: (onclick) => {
                    this.addNote(attendee.ID);
                }
            },
            {
                title: String(attendee.ID),
                label: 'Set Status to Registered',
                command: (onclick) => {
                    this.updateAttendeeStatuses(1, attendee);
                }
            },
            {
                title: String(attendee.ID),
                label: 'Set Status to Attended',
                command: (onclick) => {
                    this.updateAttendeeStatuses(2, attendee);
                }
            },
            {
                title: String(attendee.ID),
                label: 'Set Status to Cancelled',
                command: (onclick) => {
                    this.updateAttendeeStatuses(3, attendee);
                }
            },
            {
                title: String(attendee.ID),
                label: 'Set Status to No Show',
                command: (onclick) => {
                    this.updateAttendeeStatuses(5, attendee);
                }
            },
            {
                title: String(attendee.ID),
                label: 'Send Reminder Email',
                disabled: false,
                command: (onclick) => {
                    this.sendRealEmail(800, attendee);
                }
            },
            {
                title: String(attendee.ID),
                label: 'Send No Show Email',
                command: (onclick) => {
                    this.sendRealEmail(801, attendee);
                }
            },
            {
                title: String(attendee.ID),
                label: 'Send Setup Email',
                command: (onclick) => {
                    this.sendRealEmail(802, attendee);
                }
            },
            {
                title: String(attendee.ID),
                label: 'Send Certificate Email',
                command: (onclick) => {
                    this.sendRealEmail(803, attendee);
                }
            }
        ]
        if (attendee.SubscriptionNotes.length > 0) {
            actions.splice(1, 0, {
                title: String(attendee.ID),
                label: 'Delete Note',
                command: (onclick) => {
                    this.deleteNote(attendee.ID);
                }
            })
        }

        if (this.getCertificatesForType(attendee, 1).length > 0) {
            actions.push({
                title: String(attendee.ID),
                label: 'Remove Class Certificate',
                command: (onclick) => {
                    this.DeleteCertificate(attendee.ID);
                }
            })
        } else {
            actions.push({
                title: String(attendee.ID),
                label: 'Generate Class Certificate',
                disabled: this.CertDisabled(attendee),
                command: (onclick) => {
                    this.onGenerateIndividualCertificate(Number(onclick.item.title));
                }
            })
        }

        return actions;
    }

    CertDisabled(attendee: TrainingEventSubscription): boolean {
        if (moment().isBefore(this.event.EventDateTime, 'day') || attendee.AttendancestatusType == AttendanceStatusTypes.Rescheduled || attendee.AttendancestatusType == AttendanceStatusTypes.Cancelled || attendee.AttendancestatusType == AttendanceStatusTypes.NoShow) {
            return true;
        }
        return false;
    }

    IsValidAction(attendee: TrainingEventSubscription): boolean {
        if (moment().isAfter(this.event.EventDateTime, 'day') || moment().isBefore(this.event.EventDateTime, 'day') || attendee.AttendancestatusType == AttendanceStatusTypes.Rescheduled || attendee.AttendancestatusType == AttendanceStatusTypes.Cancelled || attendee.AttendancestatusType == AttendanceStatusTypes.NoShow) {
            return true;
        }
        return false;
    }

    CanDeleteEvent() {
        return moment(moment(this.event.EventDateTime).format('MM/DD/YYYY')).isSameOrAfter(moment(moment().format('MM/DD/YYYY'))) && this.roles.RestrictedAccess(1);
    }

    ColorForStatus(status: number): String {
        switch (status) {
            case 1:
                return '#000';
            case 2:
                return 'green';
            case 3:
                return 'red';
            case 4:
                return 'blue';
            case 5:
                return 'orange';
        }
    }

    NameForEmailTemplate(type: NotificationGroupReportTypes): String {
        let name: String;
        switch (type) {
            case 800:
                name = 'Reminder';
                break;
            case 801:
                name = 'Reschedule';
                break;
            case 802:
                name = 'Setup';
                break;
            case 803:
                name = 'Certificate';
                break;
            case 804:
                name = 'Registration';
                break;
            default:
                name = 'Template Not Found'
        }
        return name;
    }

    displayAttendeeInfo(attendee) {
        attendee.DisplayInfo = !attendee.DisplayInfo;
    }

    displayAllAttendeeInfo() {
        this.DisplayAllInfo = !this.DisplayAllInfo;
        this.Attendees.forEach(function (attendee) {
            attendee.DisplayInfo = this.DisplayAllInfo;
        }, this)
    }

    updateAttendeeStatuses(status: number, attendee?: TrainingEventSubscription) {
        let request: UpdateTrainingEventSubscriptionStatusesRequestArray = new UpdateTrainingEventSubscriptionStatusesRequestArray();

        if (attendee) {
            let updateAttendee: UpdateTrainingEventSubscriptionStatusesRequest = new UpdateTrainingEventSubscriptionStatusesRequest();

            updateAttendee.TrainingEventSubscriptionID = attendee.ID;
            updateAttendee.NewStatus = status;

            attendee.AttendancestatusType = status;

            request.push(updateAttendee);
        } else {
            this.SelectedAttendees.forEach(function (a) {
                let updateAttendee: UpdateTrainingEventSubscriptionStatusesRequest = new UpdateTrainingEventSubscriptionStatusesRequest();
                let person = this.Attendees.find(item => item.Attendee.ID == a.ID);

                updateAttendee.TrainingEventSubscriptionID = a.ID;
                updateAttendee.NewStatus = status;
                person.Attendee.AttendancestatusType = status;

                request.push(updateAttendee);
            }, this)
        }

        let disposable = this.api.UpdateTrainingEventSubscriptionStatuses(request).subscribe(response => {
            if (!response.Data.GoogleCalendarResult) { this.GoogleCalendarWarning() };
            // this.Attendees = this.SortedAttendees(this.Attendees);
            this.reloadActions();
            disposable.unsubscribe();
        });

        this.SelectedAttendees = [];
        this.isToggleAll = false;
    }

    labelForStatus(status: number): String {
        switch (status) {
            case 1:
                return 'Registered'
            case 2:
                return 'Attended'
            case 3:
                return 'Cancelled'
            case 4:
                return 'Rescheduled'
            case 5:
                return 'No Show'
            default:
                return 'Registered'
        }
    }

    confirmAttendeeStatus(status: number, attendee: TrainingEventSubscription): Boolean {
        if (attendee.AttendancestatusType == 1) {
            return true;
        } else {
            this.sweetAlert.swal({
                title: 'Are you sure?',
                text: 'This attendee has been ' + this.labelForStatus(attendee.AttendancestatusType) + '. Are you sure you want to change it to ' + this.labelForStatus(status) + '?',
                type: 'warning',
                showCancelButton: true
            }).then(response => {
                return response;
            }, (dismiss) => {
                return false;
            })
        }
    }

    sendRealEmail(type: TrainingEmailEventTypes, attendee?: TrainingEventSubscription) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let memberData: MemberDashboard = new MemberDashboard();
        if (attendee) {
            memberData.Email = attendee.AlternateEmail ? attendee.AlternateEmail : attendee.MemberEmail;
            memberData.ID = attendee.ID;
        }

        let dipsosable = this.dialogService.addDialog(EmailDialog, {
            Type: EmailWindowType.Training,
            Templates: [TemplateTypes.Training],
            TrainingEvent: this.event,
            TrainingEmailEventType: type,
            MemberData: memberData
        }, { width: 1100, height: 800 }).subscribe(response => {
            if (response) {
                this.loadEvent();
            }
            dipsosable.unsubscribe();
        })

        // let initData: EmailWindowRequest = {
        //     Type: EmailWindowType.Training,
        //     Templates: [TemplateTypes.Training],
        //     TrainingEvent: this.event,
        //     TrainingEmailEventType: type,
        //     MemberData: memberData
        // }

        // console.log(initData);

        // let result = this.windowService.OpenWindow<EmailWindowRequest>(WindowTypes.Email, initData, windowSettings);

        // let windowSubscription = result.onEvent.subscribe(event => {
        //     console.log("event received. My id:" + result.ID + ", event id:" + event.ID, event);

        //     if (event.ActionType == WindowActionTypes.Saved)
        //         console.log('saved');
        //     this.loadEvent();

        //     if (event.ActionType == WindowActionTypes.Close)
        //         windowSubscription.unsubscribe;

        // });
    }

    addAttendee() {
        let disposable = this.dialogService.addDialog(AddAttendeeDialog, {
            title: 'Add Attendee',
            Products: this.event.TrainingClass.ProductIDs
        }).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                this.IsBusy = true;
                let request = new AddTrainingEventSubscriptionOnlyRequest();
                request.TrainingEvent_ID = this.event.ID;
                request.License_ID = response.License_ID;
                request.AlternateEmail = response.AlternateEmail;
                request.AlternatePhone = response.AlternatePhone;
                request.AttendanceStatusType = 1;
                request.SubscriptionMethodType = SubscriptionMethodTypes.Admin;
                request.SubscriptionNotes = response.SubscriptionNotes;
                let disposable = this.api.AddTrainingEventSubscription(request).subscribe(r => {
                    if (r.Result) {
                        let attendee = new Attendee();
                        attendee.Attendee = response;
                        attendee.ID = r.Data.TrainingEventSubscriptionID;
                        attendee.Attendee.ID = r.Data.TrainingEventSubscriptionID;
                        attendee.Attendee.AttendancestatusType = 1;
                        attendee.Attendee.CertificatesAwarded = [];
                        attendee.Attendee.SubscriptionNotes = '';
                        attendee.Actions = this.ActionsForAttendee(attendee.Attendee);
                        this.event.Attendees.push(attendee.Attendee);
                        this.Attendees.push(attendee);
                    } else {
                        let eventAttendee = this.event.Attendees.find(attendee => attendee.Member_ID == response.Member_ID);
                        this.sweetAlert.swal({
                            type: 'warning',
                            title: 'Already Registered',
                            text: 'Would you like to update the existing member?',
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonText: 'Yes',
                            cancelButtonText: 'No',
                        }).then(response => {
                            if (response) {
                                this.updateAttendeeStatuses(1, eventAttendee);
                            }
                        }, (dismiss) => {

                        })
                        // let eventAttendee = this.event.Attendees.find(attendee => attendee.Member_ID == response.Member_ID);
                        // let rawAttendee = this.Attendees.find(attendee => attendee.Attendee.Member_ID == response.Member_ID);

                        // console.log(eventAttendee);
                        // console.log(rawAttendee);

                        // if(eventAttendee) {
                        //     eventAttendee.AttendancestatusType = AttendanceStatusTypes.Registered;
                        // }

                        // if(rawAttendee) {
                        //     rawAttendee.Attendee.AttendancestatusType = AttendanceStatusTypes.Registered;
                        // }
                    }
                    disposable.unsubscribe();
                    this.IsBusy = false;
                })
            }
        })
    }

    RescheduleAttendee(attendee: TrainingEventSubscription) {
        let disposable = this.dialogService.addDialog(RescheduleAttendeeDialog, {
            title: 'Reschedule Attendee',
            Attendee: attendee,
            Event: this.event
        }).subscribe(response => {
            if (response) {
                this.updateAttendeeStatuses(4, attendee);
            }
            disposable.unsubscribe();
        })
    }

    addNote(id: number) {
        let attendee: TrainingEventSubscription = this.event.Attendees.filter(a => a.ID == id)[0];
        this.sweetAlert.swal(
            {
                title: 'Note',
                input: 'text',
                inputValue: attendee.SubscriptionNotes
            }).then((response: any) => {
                if (response.length > 0 && response != attendee.SubscriptionNotes) {
                    attendee.SubscriptionNotes = response;
                    let request = new UpdateTrainingEventSubscriptionRequest();
                    request.TrainingEventSubscriptionID = attendee.ID;
                    request.License_ID = attendee.License_ID;
                    request.SubscriptionNotes = attendee.SubscriptionNotes;
                    request.AlternateEmail = attendee.AlternateEmail;
                    request.AlternatePhone = attendee.AlternatePhone;
                    request.AttendanceStatusType = attendee.AttendancestatusType;
                    request.SubscriptionMethodType = attendee.SubscriptionMethodType;
                    this.api.UpdateTrainingEventSubscription(request).subscribe(response => {
                        if (!response.Data.GoogleCalendarResult) { this.GoogleCalendarWarning() };
                    })
                    //reload actions
                    this.reloadActions();
                }
            }, (dismiss) => {
                return;
            }
            );
    }

    deleteNote(id: number) {
        let attendee: TrainingEventSubscription = this.event.Attendees.filter(a => a.ID == id)[0];
        
        attendee.SubscriptionNotes = "";

        let request = new UpdateTrainingEventSubscriptionRequest();
        request.TrainingEventSubscriptionID = attendee.ID;
        request.License_ID = attendee.License_ID;
        request.SubscriptionNotes = attendee.SubscriptionNotes;
        request.AlternateEmail = attendee.AlternateEmail;
        request.AlternatePhone = attendee.AlternatePhone;
        request.AttendanceStatusType = attendee.AttendancestatusType;
        request.SubscriptionMethodType = attendee.SubscriptionMethodType;
        this.api.UpdateTrainingEventSubscription(request).subscribe(response => {
            if (!response.Data.GoogleCalendarResult) { this.GoogleCalendarWarning() };
        })
        //reload actions
        this.reloadActions();
    }

    onMemberClick(id: number, event) {
        event.preventDefault();
        event.stopPropagation();
        this.close()
        this.router.navigate(['/member-profile', id]);
    }

    onLicenseClick(license: string) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        this.windowService.OpenWindow<string>(WindowTypes.License, license, windowSettings);
    }

    onGenerateIndividualCertificate(id: number) {
        let disposable = this.api.CertificateGenerationForTrainingEventSubscription(id).subscribe(response => {
            let attendee = this.Attendees.filter(a => a.ID == id)[0];
            attendee.Attendee.CertificateToken = response.Data.CertificateToken;
            attendee.Attendee.CertificatesAwarded.push(response.Data);
            attendee.Actions = this.ActionsForAttendee(attendee.Attendee);
            disposable.unsubscribe();
        })
        this.sendRealEmail(TrainingEmailEventTypes.Training_Event_Certificate);
    }

    generateAllCertificates() {
        let disposable = this.api.CertificateGenerationForTrainingEvent(this.event.ID).subscribe(response => {
            disposable.unsubscribe();
            this.loadEvent();

            this.SelectedAttendees = [];
            this.isToggleAll = false;

        })
        this.sendRealEmail(TrainingEmailEventTypes.Training_Event_Certificate);
    }

    getCertificatesForType(attendee: TrainingEventSubscription, type: CertificateTypes): TrainingEventSubscriptionCertificateResponseArray {
        return attendee.CertificatesAwarded.filter(cert => cert.CertificateType == type);
    }

    downloadCertificate(cert: TrainingEventSubscriptionCertificateResponse) {
        let type = 'product';
        switch (cert.CertificateType) {
            case 1:
                type = 'product';
                break;
            case 2:
                type = 'apsp';
                break;
        }
        //todo:  Update with live Reports URL before going live.
        //(<any>window).open('https://reports-api.structurestudios.com/PDF/Training/Certificate/false/' + type + '/' + cert.CertificateToken + '/' + cert.CertificateID);
        (<any>window).open('https://api-reports-ssdb3-node2.structurestudios.com/PDF/Training/Certificate/false/' + type + '/' + cert.CertificateToken + '/' + cert.CertificateID);
    }

    DeleteCertificate(id: number) {
        this.api.CertificateRemovalForTrainingEventSubscription(id).subscribe(response => {
            this.loadEvent();
        })
    }

    deleteEvent() {
        this.sweetAlert.swal({
            title: 'Are you sure?',
            text: 'This will delete the event and all attendees will be lost.',
            type: 'warning',
            showCancelButton: true,
            preConfirm: (response) => {
                return this.api.DeleteTrainingEvent(this.event.ID).toPromise();
            }
        }).then(response => {
            if (!response.Data.GoogleCalendarResult) { this.GoogleCalendarWarning() };
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Deleted Event',
                    text: 'Deleted event without any errors',
                    timer: 1500
                }).then( () => {}, () => {} )
                this.close();
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                })
            }
        }, (dismiss) => {
        })
    }

    GoogleCalendarWarning() {
        this.sweetAlert.swal({
            title: 'Google Calendar',
            text: 'Google Calendar has failed to sync due to technical difficulties. If this problem persists please contact support',
            type: 'warning'
        })
    }

    confirm(HideSwal: boolean) {
        this.IsBusy = true;
        let request: UpdateTrainingEventRequest = new UpdateTrainingEventRequest();
        let existingAttendees: UpdateTrainingEventSubscriptionRequestArray = new UpdateTrainingEventSubscriptionRequestArray();
        let newAttendees: AddTrainingEventSubscriptionRequestArray = new AddTrainingEventSubscriptionRequestArray();

        this.Attendees.forEach(function (attendee) {
            if (attendee.ID) {
                let a: UpdateTrainingEventSubscriptionRequest = new UpdateTrainingEventSubscriptionRequest();
                a.TrainingEventSubscriptionID = attendee.Attendee.ID;
                a.License_ID = attendee.Attendee.License_ID;
                a.SubscriptionNotes = attendee.Attendee.SubscriptionNotes;
                a.AttendanceStatusType = attendee.Attendee.AttendancestatusType;
                existingAttendees.push(a);
            } else {
                let a: AddTrainingEventSubscriptionRequest = new AddTrainingEventSubscriptionRequest();
                a.License_ID = attendee.Attendee.License_ID;
                a.SubscriptionMethodType = attendee.Attendee.SubscriptionMethodType;
                a.SubscriptionNotes = attendee.Attendee.SubscriptionNotes;
                a.AttendanceStatusType = attendee.Attendee.AttendancestatusType;
                newAttendees.push(a);
            }
        })

        let date = moment(this.EventForm.controls['date'].value).format('YYYY-MM-DD');
        let time = moment(this.EventForm.controls['time'].value).format('hh:mm a');
        let eventDateTime = moment(date + ' ' + time, 'YYYY-MM-DD hh:mm a').toDate();

        request.TrainerID = parseInt(this.EventForm.controls['trainer'].value);
        request.TrainingEventID = this.event.ID;
        request.TrainingClassID = this.EventForm.controls['class'].value;
        request.EventDateTime = eventDateTime;
        request.NewAttendees = newAttendees;
        request.ExistingAttendees = existingAttendees;
        request.GoToMeetingLink = this.event.GoToMeetingLink;
        request.WebinarID = this.event.WebinarID;

        let disposable = this.api.UpdateTrainingEvent(request).subscribe(response => {
            this.IsBusy = false;
            if (response.Result) {
                if (!response.Data.GoogleCalendarResult) { this.GoogleCalendarWarning() };
                disposable.unsubscribe();
                // this.close();
                if (!HideSwal) {
                    this.sweetAlert.swal({
                        title: 'Saved Event',
                        text: 'Event was saved successfully.',
                        type: 'success',
                        timer: 1500
                    }).then(() => {});
                }
            } else {
                this.sweetAlert.swal({
                    title: 'Save failed',
                    text: response.Message,
                    type: 'error'
                })
            }
        })
    }

}
